import React from "react";
import { Card } from "react-bootstrap";
import STRINGS from "../Constants/Strings";

const menuItems = [
  {
    key: "dashboard",
    icon: "fas fa-desktop",
    label: STRINGS.BRANCH.SIDEBARMENU.DASHBOARD_LABEL,
    disabled: false,
  },
  {
    key: "members",
    icon: "fas fa-users",
    label: STRINGS.BRANCH.SIDEBARMENU.MEMBERS_LABEL,
    disabled: false,
  },
  {
    key: "calendar",
    icon: "fas fa-calendar-day",
    label: STRINGS.BRANCH.SIDEBARMENU.CALENDAR_LABEL,
    disabled: true,
  },
  {
    key: "campaigns",
    icon: "fas fa-bullhorn",
    label: STRINGS.BRANCH.SIDEBARMENU.CAMPAIGNS_LABEL,
    disabled: true,
  },
  {
    key: "news",
    icon: "fas fa-rss",
    label: STRINGS.BRANCH.SIDEBARMENU.NEWS_LABEL,
    disabled: true,
  },
  {
    key: "reports",
    icon: "fas fa-chart-area",
    label: STRINGS.BRANCH.SIDEBARMENU.REPORTS_LABEL,
    disabled: true,
  },
  {
    key: "help",
    icon: "fas fa-question-circle",
    label: STRINGS.BRANCH.SIDEBARMENU.HELP_LABEL,
    disabled: true,
  },
];

export default function SidebarMenu({ activeMenu, onMenuClick }) {
  return (
    <nav className="[ branch-menu-container ]" aria-label="Primary">
      <ul className="list-unstyled">
        {menuItems.map((item, idx) => {
          const isActive = activeMenu === item.key;
          const isDisabled = item.disabled;

          return (
            <li key={item.key}>
              <button
                type="button"
                className={
                  "branch-menu-card main" +
                  (isActive ? " active" : " inactive") +
                  (idx === 0 ? " first" : "") +
                  (idx === menuItems.length - 1 ? " last" : "")
                }
                disabled={isDisabled}
                aria-current={isActive ? "page" : undefined}
                onClick={() => {
                  if (!isActive && !isDisabled) {
                    if (item.key === "members") {
                      onMenuClick("members", {
                        primaryTab: "personal",
                        secondaryTab: "members",
                      });
                    } else {
                      onMenuClick(item.key);
                    }
                  }
                }}
              >
                <i className={item.icon} aria-hidden="true" />
                <span>{item.label}</span>
              </button>
            </li>
          );
        })}
      </ul>
      <ul className="list-unstyled">
        {/* smartBranch Admin button*/}
        <li>
          <button
            type="button"
            className={
              "branch-menu-card first last" +
              (activeMenu === "smartBranch" ? " active" : " inactive")
            }
            aria-current={activeMenu === "smartBranch" ? "page" : undefined}
          >
            <i className="fas fa-user-plus" aria-hidden="true" />
            <span>{STRINGS.BRANCH.SIDEBARMENU.SMARTBRANCH_LABEL}</span>
          </button>
        </li>
      </ul>
    </nav>
  );
}
